import 'common';
import 'frontend';



// WEBPACK FOOTER //
// app/javascript/packs/frontend.js